import { render, staticRenderFns } from "./ItemSheet.vue?vue&type=template&id=16d16234&scoped=true"
import script from "./ItemSheet.vue?vue&type=script&lang=js"
export * from "./ItemSheet.vue?vue&type=script&lang=js"
import style0 from "./ItemSheet.vue?vue&type=style&index=0&id=16d16234&prod&lang=scss"
import style1 from "./ItemSheet.vue?vue&type=style&index=1&id=16d16234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d16234",
  null
  
)

export default component.exports